module.exports = __webpack_public_path__ + "static/media/jestlogo.8b7ec8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/jestlogo.png
// module id = 821
// module chunks = 0